import { render } from "./PostImageModal.vue?vue&type=template&id=34233384"
import script from "./PostImageModal.vue?vue&type=script&lang=js"
export * from "./PostImageModal.vue?vue&type=script&lang=js"
script.render = render

export default script